export enum FollowRole {
  Followers = 'followers',
  Following = 'following',
}
